import Swiper from "swiper";

let slider = new Swiper('.about-why__slider', {
    slidesPerView: 'auto',
    scrollbar: {
        el: '.about-why__slider .swiper-scrollbar',
        draggable: true,
    },
});